
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  components: {
    KeyenceHTHardKeyButton,
  },
  name: 'SkippingCustomValidationDialog',
  emits: ['proceed', 'close'],
})
export default class SkippingCustomValidationDialog extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: '' }) message!: string
  @Prop({ default: 'Custom Validation Warning' }) title!: string

  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  absorbModalHardKey(): void {
    // Out of scope: register layer via visible, but do not proceed or close.
  }

  closeDialog() {
    this.$emit('close')
  }

  proceedAnyway() {
    this.$emit('proceed')
  }
}
